import api from "../axios";

//어떤회사가  어떤역할로 참여하고 있는지 매핑
export const listPCP = (params) =>
  api.get("project-company-participants/", { params });
export const createPCP = (data) =>
  api.post("project-company-participants/", data);
export const updatePCP = (id, data) =>
  api.put(`project-company-participants/${id}/`, data);
export const patchPCP = (id, data) =>
  api.patch(`project-company-participants/${id}/`, data);
export const deletePCP = (id) =>
  api.delete(`project-company-participants/${id}/`);
